import { useState } from 'react';

const BalanceModal = ({ userId, onClose, fetchUserBalance }) => {
  const [password, setPassword] = useState('');
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleCheckBalance = async () => {
    setLoading(true);
    setErrorMsg('');
    setBalance(null);
    try {
      const token = localStorage.getItem('adminToken');
      const storedUserId = userId || localStorage.getItem('UserId');
      const result = await fetchUserBalance(storedUserId, password, token);
      setBalance(result.balance);
    } catch (error) {
      console.error('Balance fetch failed:', error);
      setErrorMsg(error.message || 'Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-80 relative">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          ✖
        </button>
        <h2 className="text-xl font-semibold mb-4 text-center">
          Enter Password to View Balance
        </h2>

        <input
          type="password"
          placeholder="Enter your password"
          className="w-full px-3 py-2 border rounded-md mb-3 focus:ring focus:ring-blue-300"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {errorMsg && (
          <p className="text-red-500 text-sm text-center mb-2">{errorMsg}</p>
        )}

        {loading ? (
          <p className="text-center text-gray-600">Checking...</p>
        ) : balance !== null ? (
          <p className="text-center text-green-600 font-semibold text-lg">
            💰 Balance: ₹{balance.toFixed(2)}
          </p>
        ) : null}

        <div className="mt-4 flex justify-center">
          <button
            onClick={handleCheckBalance}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Check Balance
          </button>
        </div>
      </div>
    </div>
  );
};

export default BalanceModal;
